export const POST_PIN_PERMISSIONS = {
  pin: 'can_pin_post',
  unpin: 'can_unpin_post',
}

export const QA_NAME_PIN_ACTION_BUTTON = 'pinBtn'
